const btnFilterManagementBackups = {
  Typography: 'No results found'
};

export default btnFilterManagementBackups;
